export default {
    methods: {
        async download(id) {
            try {
                const response = await this.api.download(id)

                if (response && response.data && response.data) {
                    let url
                    if (response.data.pdf) {
                        const blob = this.dataURItoBlob(response.data.pdf)
                        url = URL.createObjectURL(blob)
                    } else {
                        url = response.data.pdfPath
                    }
                    window.open(url, '_blank')
                } else {
                    this.$toasted.error(this.$t('messages.unknown_error'))
                }
            } catch (e) {
                console.error(e)
            }
        },
        dataURItoBlob(dataURI) {
            const byteString = window.atob(dataURI)
            const arrayBuffer = new ArrayBuffer(byteString.length)
            const int8Array = new Uint8Array(arrayBuffer)
            for (let i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i)
            }
            const blob = new Blob([int8Array], { type: 'application/pdf' })
            return blob
        },
    }
}